import React from "react";
import styled from "styled-components";
import { H1Style } from "storybook-components/Typography";
import Container from "storybook-components/Container";
import LargeHubCardContainer from "./LargeHubCardContainer";
import LargeHubLinkCard from "./LargeHubLinkCard";
import HashLinkWrapper from "./HashLinkWrapper";

const BackgroundColorWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.green1};
`;

const StyledContainer = styled(Container)`
  padding: 0;
  ${({ theme }) => theme.media.tabletUp`
    padding: unset;
  `};
`;

const StyledTitleText = styled.h2`
  ${H1Style};
  color: ${({ theme }) => theme.colors.green5};
  text-align: center;
  margin-top: 0;
  padding-top: 80px;
  ${({ theme }) => theme.media.tabletUp`
    margin: 0 auto 92px;
  `};
`;

const LargeHubLinkSection = ({ sectionTitle, cardList }) => {
  return (
    <BackgroundColorWrapper>
      <StyledContainer>
        <HashLinkWrapper id="get-more-out-of-mode">
          <StyledTitleText>{sectionTitle}</StyledTitleText>
        </HashLinkWrapper>
        <LargeHubCardContainer>
          {cardList.map(({ title, subTitle, buttonHref }) => (
            <LargeHubLinkCard
              key={title}
              title={title}
              subTitle={subTitle}
              buttonHref={buttonHref}
            />
          ))}
        </LargeHubCardContainer>
      </StyledContainer>
    </BackgroundColorWrapper>
  );
};

export default LargeHubLinkSection;
